const BIO_TYPES = ['personal', 'professional', 'political'];
const WITHDRAWN_MISSING_DATA_REASON = 'no-public-info';

const resetCandidateProfile = (draft) => {
  if (!draft) return draft;

  return {
    ...draft,
    bios: BIO_TYPES.map((type) => ({
      text: '',
      sources: [],
      complete: false,
      ...(draft.bios || []).find((bio) => bio.type === type),
      type,
      missingData: WITHDRAWN_MISSING_DATA_REASON,
    })),
    issues: (draft.issues || []).map((issue) => ({
      ...issue,
      missingData: WITHDRAWN_MISSING_DATA_REASON,
    })),
  };
};

export { resetCandidateProfile };
